<app-nav-bar/>
<app-hero-terapia-fisica/>
<app-services-terapia-fisica/>
<app-recomendations-terapia-fisica/>
<app-promociones-terapia-fisica/>
<app-info-terapia-fisica/>
<app-footer-persona/>
<app-float-button/>
